import React, { useEffect } from "react";
import ReactFlow from "reactflow";
import { FaBox, FaHandHolding, FaTrashAlt, FaTools, FaPlane, FaGraduationCap } from "react-icons/fa"; // Import React Icons
import "reactflow/dist/style.css";
import Typography from '@mui/material/Typography';

const nodeSpacing = 180; // Space between nodes
const padding = 40; // Padding between nodes

const initialNodes = [
    {
        id: "1",
        data: {
            label: (
                <div style={{ textAlign: "center" }}>
                    <FaHandHolding size={30} color="#007BFF" />
                    <div style={{ marginTop: "10px", fontSize: "0.8rem", fontWeight: "bold" }}>
                        <Typography
                            component="span"
                            variant="h2"
                            sx={(theme) => ({
                                color: 'primary.main',
                                ...theme.applyStyles('dark', {
                                    color: 'primary.light',
                                    fontFamily: 'sans-serif', // Minimalistic font

                                }),
                            })}
                        >
                            Receive Devices.
                        </Typography>
                    </div>
                </div>
            ),
        },
        position: { x: 0, y: 50 },
        style: {
            background: "transparent", // Clear the background of the node
            color: "black", // Text color
            padding: "20px 40px",
            borderRadius: "12px",
            fontFamily: 'sans-serif', // Minimalistic font

        },
    },
    {
        id: "2",
        data: {
            label: (
                <div style={{ textAlign: "center" }}>
                    <FaTrashAlt size={30} color="#007BFF" />
                    <div style={{ marginTop: "10px", fontSize: "0.8rem", fontWeight: "bold" }}>
                        <Typography
                            component="span"
                            variant="h2"
                            sx={(theme) => ({
                                color: 'primary.main',
                                ...theme.applyStyles('dark', {
                                    color: 'primary.light',
                                    fontFamily: 'sans-serif', // Minimalistic font

                                }),
                            })}
                        >
                            Erase Data.
                        </Typography>
                    </div>
                </div>
            ),
        },
        position: { x: nodeSpacing + padding, y: 50 },
        style: {
            background: "transparent", // Clear the background of the node
            color: "black", // Text color
            padding: "20px 40px",
            borderRadius: "12px",
            fontFamily: 'sans-serif', // Minimalistic font

        },
    },
    {
        id: "3",
        data: {
            label: (
                <div style={{ textAlign: "center" }}>
                    <FaTools size={30} color="#007BFF" />
                    <div style={{ marginTop: "10px", fontSize: "0.8rem", fontWeight: "bold" }}>
                        <Typography
                            component="span"
                            variant="h2"
                            sx={(theme) => ({
                                color: 'primary.main',
                                ...theme.applyStyles('dark', {
                                    color: 'primary.light',
                                    fontFamily: 'sans-serif', // Minimalistic font

                                }),
                            })}
                        >
                            "refrb" Devices.
                        </Typography>
                    </div>
                </div>
            ),
        },
        position: { x: nodeSpacing * 2 + padding * 2, y: 50 },
        style: {
            background: "transparent", // Clear the background of the node
            color: "black", // Text color
            padding: "20px 40px",
            borderRadius: "12px",
            fontFamily: 'sans-serif', // Minimalistic font

        },
    },
    {
        id: "4",
        data: {
            label: (
                <div style={{ textAlign: "center" }}>
                    <FaPlane size={30} color="#007BFF" />
                    <div style={{ marginTop: "10px", fontSize: "0.8rem", fontWeight: "bold" }}>
                        <Typography
                            component="span"
                            variant="h2"
                            sx={(theme) => ({
                                color: 'primary.main',
                                ...theme.applyStyles('dark', {
                                    color: 'primary.light',
                                    fontFamily: 'sans-serif', // Minimalistic font

                                }),
                            })}
                        >
                            Ship Overseas.
                        </Typography>
                    </div>
                </div>
            ),
        },
        position: { x: nodeSpacing * 3 + padding * 3, y: 50 },
        style: {
            background: "transparent", // Clear the background of the node
            color: "black", // Text color
            padding: "20px 40px",
            borderRadius: "12px",
            fontFamily: 'sans-serif', // Minimalistic font

        },
    },
    {
        id: "5",
        data: {
            label: (
                <div style={{ textAlign: "center" }}>
                    <FaGraduationCap size={30} color="#007BFF" />
                    <div style={{ marginTop: "10px", fontSize: "0.8rem", fontWeight: "bold" }}>
                        <Typography
                            component="span"
                            variant="h2"
                            sx={(theme) => ({
                                color: 'primary.main',
                                ...theme.applyStyles('dark', {
                                    color: 'primary.light',
                                    fontFamily: 'sans-serif', // Minimalistic font

                                }),
                            })}
                        >
                            Supply Schools.
                        </Typography>
                    </div>
                </div>
            ),
        },
        position: { x: nodeSpacing * 4 + padding * 4, y: 50 },
        style: {
            background: "transparent", // Clear the background of the node
            color: "black", // Text color
            padding: "20px 40px",
            borderRadius: "12px",
            fontFamily: 'sans-serif', // Minimalistic font

        },
    },
];

const initialEdges = [
    { id: "e1-2", source: "1", target: "2", animated: true },
    { id: "e2-3", source: "2", target: "3", animated: true },
    { id: "e3-4", source: "3", target: "4", animated: true },
    { id: "e4-5", source: "4", target: "5", animated: true },
];

function StaticFlowChart() {
    useEffect(() => {
        // Inject custom CSS to hide the watermark
        const style = document.createElement("style");
        style.textContent = `
      .react-flow__attribution {
        display: none !important;
      }
    `;
        document.head.appendChild(style);
        return () => {
            document.head.removeChild(style);
        };
    }, []);

    return (
        <div
            style={{
                paddingTop: "20px",
                height: "70vh", // Increased height to fit more nodes
                width: "90%", // Set to 90% for better fitting
                margin: "auto",
                display: "flex",
                justifyContent: "center",
                alignItems: "center", // Vertically center the content
                background: "linear-gradient(45deg, rgba(255, 255, 255, 0.2) 25%, transparent 25%) 0px 0px, linear-gradient(45deg, rgba(255, 255, 255, 0.2) 25%, transparent 25%) 50% 50%",
                background: "radial-gradient(circle, rgba(255, 255, 255, 0.2) 1px, transparent 1px)",
                backgroundSize: "20px 20px", // Size of the dots
                overflowX: "auto", // Allow horizontal scrolling on smaller screens
                overflowY: "auto", // Allow vertical scrolling
                WebkitOverflowScrolling: "touch", // Smooth scrolling on mobile devices
            }}
        >
            <ReactFlow
                nodes={initialNodes}
                edges={initialEdges}
                fitView={true} // Ensures everything is visible in the container
                panOnDrag={false}
                zoomOnScroll={true}
                zoomOnPinch={true}
                zoomOnDoubleClick={true}
                elementsSelectable={false}
                style={{
                    background: "none",
                    width: "100%",
                    height: "100%",
                    flexShrink: 0, // Ensures ReactFlow doesn't shrink
                }}
            />
        </div>
    );
}

export default StaticFlowChart;
